export default __webpack_public_path__ + "static/6825-0158c9b939826d18884e1c920691ae2d.jpg";